import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSeriesShowContext } from "../SeriesShowApp";
import { formatCurrencySymbol } from "../../../shared/teamCurrencyFormatting";

const SeriesFinanceCards = () => {
  const { series, listedAsCollection } = useSeriesShowContext();
  const noun = listedAsCollection ? "Collection" : "Series";
  const path = series.finance_rollup_path;
  const scheduleKey = (series.schedule || [])
    .map((row) => `${row.calendar_event_id}:${row.classification}`)
    .join(",");
  const [rollup, setRollup] = useState(null);

  useEffect(() => {
    if (!path) return undefined;
    let cancelled = false;
    axios
      .get(path)
      .then((response) => {
        if (!cancelled) setRollup(response.data.finance_rollup);
      })
      .catch(() => {
        if (!cancelled) setRollup(null);
      });
    return () => {
      cancelled = true;
    };
  }, [path, scheduleKey]);

  if (!rollup) return null;
  if (![rollup.income_cents, rollup.expense_cents].every(Number.isFinite)) return null;

  const incomeDollars = Math.round(rollup.income_cents / 100);
  const expenseDollars = Math.round(rollup.expense_cents / 100);
  const netDollars = incomeDollars - expenseDollars;
  const symbol = formatCurrencySymbol(series.base_currency_symbol);
  const fmt = (dollars) =>
    (dollars < 0 ? "-" : "") + symbol + Math.abs(dollars).toLocaleString("en-US");
  const netClass = netDollars >= 0 ? "series-finance-net-positive" : "series-finance-net-negative";

  return (
    <div className="series-kpi-grid">
      <div className="series-kpi-card">
        <div className="series-kpi-label">{noun} income</div>
        <div className="series-kpi-value">{fmt(incomeDollars)}</div>
        <div className="series-kpi-sub">Tickets + all other show revenue</div>
      </div>
      <div className="series-kpi-card">
        <div className="series-kpi-label">{noun} expenses</div>
        <div className="series-kpi-value">{fmt(expenseDollars)}</div>
        <div className="series-kpi-sub">All show expenses</div>
      </div>
      <div className="series-kpi-card">
        <div className="series-kpi-label">{noun} net</div>
        <div className={`series-kpi-value ${netClass}`}>{fmt(netDollars)}</div>
        <div className="series-kpi-sub">Income minus expenses</div>
      </div>
    </div>
  );
};

export default SeriesFinanceCards;
